import { render, staticRenderFns } from "./ConversationNewDesktop.vue?vue&type=template&id=365ffc3d&"
import script from "./ConversationNewDesktop.vue?vue&type=script&lang=js&"
export * from "./ConversationNewDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ConversationNewDesktop.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports